import fetch from '@/common/utils/serFetch'
import { APICUS } from '@public/utils/const'

const moduleList = {
  customerStaffManager: `${APICUS}/staffManager`, // 客服管理
  public: `${APICUS}/public` // 客服管理
}

// 在线客服 成员管理 => 客服管理
export const memberManage = {

  reqList: (params) => fetch.get(`${moduleList.customerStaffManager}/bpoUser/pageAllInfo`, { params }),
  reqDetail: `${moduleList.customerStaffManager}/bpoUser/detail`,


  //技能组
  reqGroupList: (params) => fetch.get(`${moduleList.public}/getSkillGroupConfigurationForSelect`, { params }),
  sysStaffUrl: `${moduleList.public}/getOpUserWebForSelect`,  //客服列表
    //修改
    reqUpdate: (reqData) => fetch.post(`${APICUS}/imCcAccountApplyRecord/updateApply`, reqData),

  // 客服列表
  extnoList: `${moduleList.public}/restService/getExtnoList`,// 分机号
  reqXuanMiList:`${APICUS}/imCcAccountApplyRecord/xuanMi/seatExtensionNumber`,
  // reqDetail: (params) => fetch.get(`${moduleList.customerStaffManager}/detail?id=` + params.id)
  // 技能组列表
  // reqGroupList: (params) => fetch.get(`${APICUS}/skillGroupConfiguration/page`, { params }),
  reqServiceInfo:()=>fetch.get(`${APICUS}/imCcAccountApplyRecord/getServiceInfo`),
  reqAddApply:(params)=>fetch.post(`${APICUS}/imCcAccountApplyRecord/addApply`, params),
  // 导入
  reqInputExcel: uploadFile => fetch.post(`/bpo/imCcAccountApplyRecord/batchImport`, uploadFile, { timeout: 20000 }),
   // 下载模板
   templateDown:()=>fetch.download(`/bpo/imCcAccountApplyRecord/import/template/down`),
  // 导入列表数据
  reqInputList(params) {
    return fetch.post(`/bpo/imCcAccountApplyRecord/import/log/page`,  params )
  },
  // 下载成功/失败文件
  reqSuccessFailExcel(reqData) {
    return fetch.post(`/bpo/imCcAccountApplyRecord/import/log/export`, reqData, { responseType: 'arraybuffer', handle: true })
  }
}
export const customerNew = {
  reqList: (params) => fetch.post(`${APICUS}/imCcAccountApplyRecord/page`,   params  ),
  reqServiceInfo:()=>fetch.get(`${APICUS}/imCcAccountApplyRecord/getServiceInfo`),
  reqAddApply:(params)=>fetch.post(`${APICUS}/imCcAccountApplyRecord/addApply`, params)

}
export const  getUserInfo = (params)=>fetch.get(`/bpo/imCcAccountApplyRecord/getUserWorkPlaceList`,{params})
